"use client";
import { useEffect, useState } from "react";
import { Button } from "~/components/v3/themed/Button";

import { rejectPromptProposeEvent } from "../../actions";

import { Community } from "@prisma/client";
import ProposeEventModal from "~/components/v3/modals/ProposeEventModal";
import Modal from "~/components/v3/themed/Modal";

const PromptProposeAnEvent = ({
    nearbyUsers,
    community,
}: {
    nearbyUsers?: number | false;
    community: Pick<
        Community,
        | "id"
        | "name"
        | "slug"
        | "image"
        | "defaultTags"
        | "forceUseOfTemplatedEvent"
        | "hostRequiredData"
    >;
}) => {
    const [promptOpen, setPromptOpen] = useState(false);
    const [proposeEventOpen, setProposeEventOpen] = useState(false);

    // Give the user 30 seconds before showing the prompt
    // This also helps to prvent hydration errors
    useEffect(() => {
        setTimeout(() => {
            if (nearbyUsers && nearbyUsers > 0) {
                setPromptOpen(true);
            }
        }, 10000);
    }, [nearbyUsers]);

    const handleRejectProposeEvent = () => {
        rejectPromptProposeEvent();
        setPromptOpen(false);
    };

    const handleProposeEvent = () => {
        setProposeEventOpen(true);
        setPromptOpen(false);
    };

    return (
        <>
            <Modal
                open={promptOpen}
                onOpenChange={setPromptOpen}
                title={`There are ${nearbyUsers} ${community.name} fans near you!`}
                description="Propose an event so you can hangout!"
                footer={
                    <>
                        <Button
                            variant="secondary"
                            onClick={handleRejectProposeEvent}
                        >
                            Not now
                        </Button>
                        <Button onClick={handleProposeEvent}>
                            Propose an event
                        </Button>
                    </>
                }
            ></Modal>
            <ProposeEventModal
                community={community}
                setOpen={setProposeEventOpen}
                open={proposeEventOpen}
            />
        </>
    );
};

export default PromptProposeAnEvent;
